import { Text, View } from "@react-pdf/renderer";
import { formatDateTimeUtc } from "../../../../utils/date_formatter";
import { convertSnakeCaseToTitleCase } from "../../../../utils/string_convert_helper";
import { styles } from "../../ReactPdfStyles";

type AuditDetailSectionTypes = {
	data: Record<string, any>;
	renderFiles: () => React.ReactNode;
};

export function AuditDetailSection({
	data,
	renderFiles,
}: AuditDetailSectionTypes) {
	return (
		<View style={[styles.section, styles.tableFontSize]}>
			<Text style={styles.tableHeader}>Audit detail</Text>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Tenant</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{data.operator ?? "—"}
				</Text>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Audit type</Text>
				<Text style={styles.valueCell}>
					{data.audit_type ? convertSnakeCaseToTitleCase(data.audit_type) : "—"}
				</Text>

				<Text style={styles.labelCell}>Date and time of audit</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{formatDateTimeUtc(data.date_and_time_of_audit ?? "")}
				</Text>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Department</Text>
				<Text style={styles.valueCell}>{data.department ?? "—"}</Text>

				<Text style={styles.labelCell}>Auditor</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{data.auditor_name
						? data.auditor_name + " (" + data.auditor + ")"
						: (data.auditor ?? "—")}
				</Text>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Customer</Text>
				<Text style={styles.valueCell}>{data.customer ?? "—"}</Text>

				<Text style={styles.labelCell}>Auditee</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{data.auditee ?? "—"}
				</Text>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Summary</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{data.summary ?? "—"}
				</Text>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>File upload(s)</Text>
				<View style={[styles.valueCell, styles.borderRight]}>
					{renderFiles()}
				</View>
			</View>
		</View>
	);
}

export default AuditDetailSection;
